import React from "react";
import sectionBG from "../../../images/blog/whatsup-bg.png";
import ArticleMegaCard from "./articleMegaCard";
import { getSourceImageUrlToCGI } from "../../../utils/base";

const WhatsupNext = ({ article }) => {
  const featuredImage = article?.globalConfig?.backgroundImage ?? null;
  return (
    <section
      className="relative bg-center bg-no-repeat bg-cover flex justify-center sm:block min-h-[680px] sm:min-h-fit mt-[300px] sm:mt-0"
      style={{
        backgroundImage: `url('${
          getSourceImageUrlToCGI({ uri: featuredImage?.sourceUrl }) ?? sectionBG
        }')`
      }}
    >
      <div className="relative justify-end block w-11/12 mx-auto sm:w-10/12 sm:flex">
        <div className="absolute w-full mb-20 sm:top-0 sm:w-1/2 -top-1/4 sm:relative">
          <ArticleMegaCard article={article} />
        </div>
      </div>
    </section>
  );
};

export default WhatsupNext;
